// Configuration par défaut du formulaire : neutre, sans lien ni coordonnée d'école.
// Sert de repli si l'API /api/form-config est indisponible.
// Doit rester alignée avec les valeurs par défaut du backend (FormConfigService).
export const DEFAULT_FORM_CONFIG = {
  title: "Formulaire d'inscription",
  subtitle: "",
  blocks: [
    {
      type: "TEXT",
      framed: true,
      title: "Ceci est un formulaire d'inscription",
      content:
        "Pour toute question avant de vous inscrire, contactez directement l'école.",
    },
    {
      type: "CONDITION",
      framed: false,
      title: "Conditions générales",
      content:
        "J'ai lu et accepté les conditions générales de vente ainsi que le règlement d'ordre intérieur.",
    },
    {
      type: "TEXT",
      framed: false,
      title: "",
      content:
        "Une fois le formulaire correctement complété et validé vous recevrez un mail de confirmation de soumission. Veuillez vérifier vos spams. Si vous n'avez rien reçu c'est que votre envoi a échoué.",
    },
  ],
};

export const normalizeFormConfig = (config) => {
  if (!config || !Array.isArray(config.blocks) || !config.blocks.length) {
    return DEFAULT_FORM_CONFIG;
  }
  return config;
};
